
import { Capacitor } from '@capacitor/core';

export default {
    computed: {
        isNative() {
            return Capacitor.isNative;
        },
    }
};
